export default "__VITE_ASSET__CcrONCLS__"